import { Container, ContainerProps } from '@mui/material';
import { styled } from '@mui/system';
import { PropsWithChildren } from 'react';
// This component cannot use Theme.
const StyledContainer = styled(Container)<ContainerProps>(() => ({
  height: '100%',
  width: 'auto',
  backgroundColor: '#ffffff',
}));

export function FullScreenWhiteSpace({ children }: PropsWithChildren) {
  return (
    <StyledContainer disableGutters maxWidth={false}>
      {children}
    </StyledContainer>
  );
}
